export const environment = {
    production: true,
    spaUrl: document.baseURI
}